import React from 'react';

/**
 * Store-wide price display. On sale: the original price greyed out and struck through,
 * followed by the sale price in bold at 1.2x the original's size.
 * `className` sets the base (original-price) font size, e.g. "text-sm" or "text-2xl".
 */
export default function PriceTag({ now, was, className = 'text-base', saleColor = 'text-coral-600', regularColor = 'text-ink' }) {
  const onSale = was != null && was > now;
  return (
    <span className={`inline-flex items-baseline gap-2 flex-wrap ${className}`} data-testid="price-tag">
      {onSale && (
        <span className="text-ink/40 line-through decoration-ink/40 decoration-[1.5px]" aria-label={`Was $${was.toFixed(2)}`}>
          ${was.toFixed(2)}
        </span>
      )}
      <span className={`font-bold leading-none ${onSale ? saleColor : regularColor}`} style={{ fontSize: '1.2em' }}
        aria-label={onSale ? `Now $${now.toFixed(2)}` : undefined}>
        ${now.toFixed(2)}
      </span>
    </span>
  );
}
